import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=97c53b86&scoped=true&"
import script from "./BaseAvatar.vue?vue&type=script&lang=js&"
export * from "./BaseAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=97c53b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c53b86",
  null
  
)

export default component.exports